export class SeededRandom {
  private seed: number;
  constructor(seed: number) { this.seed = seed; }
  private next(): number {
    let t = (this.seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  nextFloat(): number { return this.next(); }
  nextInt(min: number, max: number): number { return Math.floor(this.nextFloat() * (max - min)) + min; }
  nextBool(): boolean { return this.nextFloat() >= 0.5; }
  nextElement<T>(array: T[]): T { return array[this.nextInt(0, array.length)]; }
  reseed(seed: number): void { this.seed = seed; }
  getSeed(): number { return this.seed; }
}
